// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const resetProductsByCustomer = () => ({
    type: actions.RESET_PRODUCTS_BY_CUSTOMER_SEARCH_RESULTS
});



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/reset-products-by-customer.js